export const SYSTEM_CARD_FIELDS = [
  { key: "customer", label: "Customer" },
  { key: "workflow", label: "Workflow" },
  { key: "folder", label: "Folder" },
  { key: "duration", label: "Duration" },
  { key: "stage", label: "Stage" },
  { key: "allocated", label: "Allocated Users" },
  { key: "stageAssignee", label: "Stage Assignee" },
];

export const DEFAULT_CARD_FIELD_ORDER = SYSTEM_CARD_FIELDS.map((f) => f.key);

export function buildOrderedFieldKeys(cardFieldOrder, customCardFieldKeys) {
  const systemKeys = DEFAULT_CARD_FIELD_ORDER;
  const allKnownKeys = [...systemKeys, ...customCardFieldKeys];

  const saved = Array.isArray(cardFieldOrder) ? cardFieldOrder : [];
  const validSaved = saved.filter((k) => allKnownKeys.includes(k));

  const missing = allKnownKeys.filter((k) => !validSaved.includes(k));
  return [...validSaved, ...missing];
}
